import { ContractAsset } from "../../classes";

const ContractAssetModule = {
  namespaced: true,
  state: {
    contractAssets: [],
    contractAsset: {}
  },
  actions: {
    getContractAssetsByContract: async ({ dispatch, commit, rootGetter }, payload) => {
      try {
        const params = Object.assign({}, payload);
        commit("setContractAssets", []);
        const data = await ContractAsset.getContractAssetsByContract(params);
        commit("setContractAssets", data);
        return data;
      } catch (e) {
        throw e;
      }
    },
    getContractAsset: async ({ dispatch, commit, rootGetter }, payload) => {
      try {
        commit("setContractAsset", null);
        const params = Object.assign({}, payload);
        const data = await ContractAsset.getContractAsset(params);
        commit("setContractAsset", data);
        return data;
      } catch (e) {
        throw e;
      }
    },
    createContractAsset: async ({ dispatch, commit, rootGetter }, payload) => {
      try {
        const params = Object.assign(
          { parameter: payload.subParameter },
          payload
        );
        const data = await ContractAsset.createContractAsset(params);
        return data;
      } catch (e) {
        throw e;
      }
    },
    updateContractAsset: async ({ dispatch, commit, rootGetter }, payload) => {
      try {
        const params = Object.assign(
          { parameter: payload.subParameter },
          payload
        );
        const data = await ContractAsset.updateContractAsset(params);
        return data;
      } catch (e) {
        throw e;
      }
    },
    removeContractAsset: async ({ dispatch, commit, rootGetter }, payload) => {
      try {
        const params = Object.assign(
          { parameter: payload.subParameter },
          payload
        );
        const data = await ContractAsset.removeContractAsset(params);
        return data;
      } catch (e) {
        throw e;
      }
    }
  },
  getters: {
    getContractAsset: state => state.contractAsset,
    getContractAssets: state => state.contractAssets
  },
  mutations: {
    setContractAsset: (state, payload) => {
      state.contractAsset = payload;
    },
    setContractAssets: (state, payload) => {
      state.contractAssets = payload;
    }
  }
};

export default ContractAssetModule;
